import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { CommandPalette } from '@/components/common/CommandPalette';

export const Layout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#FFFDF7', backgroundImage: 'repeating-linear-gradient(-45deg, transparent, transparent 24px, rgba(26,26,46,0.025) 24px, rgba(26,26,46,0.025) 26px)' }}>
      <Sidebar mobileOpen={sidebarOpen} onMobileClose={() => setSidebarOpen(false)} />
      <div className="md:pl-64 flex flex-col min-h-screen relative">
        <Header onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 relative overflow-hidden">
          {/* Decorative retro shapes — inside main content only */}
          <div className="absolute inset-x-0 top-0 h-[400px] overflow-hidden pointer-events-none" aria-hidden="true">
            <div className="absolute top-20 right-[15%] w-16 h-16 bg-orange-200/20 border-2 border-[#1a1a2e]/10 rounded-full" />
            <div className="absolute top-[35%] right-[8%] w-12 h-12 bg-pink-200/15 border-2 border-[#1a1a2e]/10 rounded-xl rotate-12" />
            <div className="absolute bottom-[20%] right-[20%] w-10 h-10 bg-cyan-200/10 border-2 border-[#1a1a2e]/10 rotate-45" />
            <div className="absolute top-[60%] left-[20%] w-14 h-14 bg-yellow-200/10 border-2 border-[#1a1a2e]/10 rounded-lg -rotate-6" />
            <div className="absolute bottom-32 left-[45%] w-8 h-8 bg-violet-200/15 border-2 border-[#1a1a2e]/10 rounded-full" />
            <div className="absolute top-40 left-[50%] w-10 h-10 bg-emerald-200/10 border-2 border-[#1a1a2e]/10 rounded-xl rotate-45" />
          </div>
          <div className="relative py-6 px-4 sm:px-6 lg:px-8">
            <Outlet />
          </div>
        </main>
      </div>
      <CommandPalette />
    </div>
  );
};
